import React, { useState, useEffect } from 'react';
import { API } from '@/App';
import axios from 'axios';

const PartnerLogos = () => {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    fetchPartners();
  }, []);

  const fetchPartners = async () => {
    try {
      const response = await axios.get(`${API}/partnerships`);
      setPartners(response.data.filter(p => p.logo_url));
    } catch (error) {
      console.error('Failed to fetch partners:', error);
    }
  };

  if (partners.length === 0) return null;

  return (
    <section className="bg-white/60 backdrop-blur-sm py-12" data-testid="partner-logos">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8">
          <h3 className="text-2xl font-semibold mb-2" style={{ fontFamily: 'Cormorant Garamond, serif', color: '#881337' }}>
            Our Partners
          </h3>
          <p className="text-gray-600">Proudly supporting women in business</p>
        </div>
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12 max-w-5xl mx-auto">
          {partners.map((partner) => (
            <a
              key={partner.id}
              href={partner.website_url || '#'}
              target="_blank"
              rel="noopener noreferrer"
              className="grayscale hover:grayscale-0 transition-all opacity-60 hover:opacity-100"
            >
              <img 
                src={partner.logo_url} 
                alt={partner.partner_name}
                className="h-12 md:h-16 w-auto object-contain"
              />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnerLogos;